<template>
    <v-content
        class="pa-0 ma-0"
    >
            <!--------------------------------->
            <!--       Main App Header       -->
            <!--------------------------------->
        <v-app-bar
            app
            fixed
            color="grey lighten-4"
            elevation="1"
        >
            <v-row
                justify="center"
                no-gutters
            >
                <v-col
                    cols=12
                    xs="12"
                    sm="12"
                    md="10"
                    lg="8"
                    xl="9"
                >
                    <v-row
                        align="center"
                        justify="space-between"
                        no-gutters
                    >
            <!--         Left Slot         -->
                        <v-col
                            class="ma-0 ml-1 pa-0"
                        >
                            <v-row
                                v-if="showHeader"
                                align="center"
                                no-gutters
                            >
                                <router-link
                                    to="/"
                                >
                                <v-col
                                    class="shrink ma-0 ml-2 mr-1 pa-0 pl-1"
                                >
                                    <v-img
                                        src="@/assets/favicon2.png"
                                        height="35"
                                        width="35"
                                    />
                                </v-col>
                                <!-- <v-col
                                    class="logo"
                                >
                                    SmartFoodPlanner
                                </v-col> -->
                                </router-link>
                            </v-row>
                            <v-row
                                v-if="!showHeader && (account.account_type != 'admin' && account.account_type != 'super admin')"
                                align="center"
                                no-gutters
                            >
                                <v-btn
                                    icon
                                    medium
                                    class="mx-0"
                                    @click.prevent="redirectToMenu"
                                >
                                    <v-icon>
                                        date_range
                                    </v-icon>
                                </v-btn>
                            </v-row>
                            <v-row
                                v-if="!showHeader && (account.account_type == 'admin' || account.account_type == 'super admin')"
                                align="center"
                                no-gutters
                            >
                                <v-switch
                                    v-model="adminView"
                                    hide-details
                                    color="#74cf74"
                                ></v-switch>
                                <v-icon
                                    :color="adminView == true ? '#74cf74' : 'grey lighten-1'"
                                >
                                    admin_panel_settings
                                </v-icon>
                            </v-row>
                        </v-col>

            <!--        Center Slot        -->
                    <v-col
                        class="shrink"
                    >
                    <v-row
                        v-if="showHeader"
                        align="center"
                        justify="center"
                        no-gutters
                    >
                        <router-link
                        to="/signup"
                        >
                        <v-col
                            class="nav1"
                        >
                            TRY IT FREE
                        </v-col>
                        </router-link>
                    </v-row>
                    <v-row
                        v-else
                        align="center"
                        justify="center"
                        no-gutters
                    >
                        <v-col
                        class="logo"
                        >
                        SmartFoodPlanner
                        </v-col>
                    </v-row>
                    </v-col>

            <!--         Log In/Menu        -->
                    <v-col
                        class="ma-0 mr-1 pa-0"
                    >
                    <v-row
                        justify="end"
                        no-gutters
                    >
                        <v-col
                        v-if="!signedIn"
                        class="ma-0 pa-0 text-right shrink"
                        >

                <!--        Log In Dialog       -->
                        <v-dialog
                            v-model="authDialog"
                            persistent
                            width="500"
                        >
                            <template
                                v-slot:activator="{ on }"
                            >
                            <v-col
                                @click.prevent="openAuthDialog"
                                v-on="on"
                            >
                                <a>
                                <v-col
                                    class="nav1"
                                >
                                    LOG IN
                                </v-col>
                                </a>
                            </v-col>
                            </template>
                            <v-card
                            style="overflow-x: hidden; overflow-y: hidden"
                            class="ma-0 pa-0"
                            >                   
                            <v-row
                                no-gutters
                            >
                                <v-btn
                                absolute
                                small
                                fab
                                top
                                right
                                @click="closeAuthDialog"
                                class="mt-8"
                                >
                                <v-icon>
                                    close
                                </v-icon>
                                </v-btn>
                                <v-col
                                class="ma-0 pa-0"
                                >
                                <Authorization/>
                                </v-col>
                            </v-row>
                            </v-card>
                        </v-dialog>
                        </v-col>

                <!--   Menu Icon for logged in users  -->
                        <v-col
                        v-else
                        class="ma-0 pa-0 shrink"
                        >
                        <v-btn
                            icon
                            medium
                            class="mx-0"
                            @click.prevent="menu = !menu"
                        >
                            <v-icon>
                            menu
                            </v-icon>
                        </v-btn>
                        </v-col>
                    </v-row>
                    </v-col>

                </v-row>
                </v-col>
            </v-row>
        </v-app-bar>

            <!--------------------------------->
            <!--      Navigation Drawer      -->
            <!--------------------------------->
        <v-navigation-drawer
            right
            v-model="menu"
            app
            temporary
        >
            <v-list>

                <!--          Close Menu         -->
                <v-row
                align="center"
                >
                <v-hover
                    v-slot:default="{ hover }"
                >
                    <v-card
                        flat
                        class="ma-0 px-5 py-2 text-center"
                        style="width: 100%;"
                        cols="12"
                        @click.prevent="menu = false"
                        :color="hover ? focusColor : mainColor"
                    >
                    <v-btn
                        icon
                        medium
                        class="mr-1"
                    >
                        <v-icon
                        medium
                        color="grey darken-3"
                        >
                        close
                        </v-icon>
                    </v-btn>
                    </v-card>
                </v-hover>
                </v-row>

                <v-divider
                class="mb-4"
                >
                </v-divider>

                <!--     Navigation Options      -->
                <v-row
                    v-for="(page, p) in nav"
                    :key="p"
                    align="center"
                >
                <v-hover
                    v-if="!(adminView == false && page.access == 'admin')"
                    v-slot:default="{ hover }"
                >
                    <v-card
                        flat
                        :to="{name: page.href}"
                        class="ma-0 px-5 py-2"
                        style="width: 100%;"
                        cols="12"
                        :color="hover ? focusColor : mainColor"
                    >
                    <v-btn
                        icon
                        medium
                        class="mr-1"
                    >
                        <v-icon
                            medium
                            color="grey darken-3"
                        >
                            {{page.icon}}
                        </v-icon>
                    </v-btn>
                        {{page.title}}
                    </v-card>
                </v-hover>
                </v-row>

                <!--           Sign Out          -->
                <v-row
                    align="center"
                >
                <v-hover
                    v-slot:default="{ hover }"
                >
                    <v-card
                        flat
                        class="ma-0 px-5 py-2"
                        style="width: 100%;"
                        cols="12"
                        @click.prevent="signOut"
                        :color="hover ? focusColor : mainColor"
                    >
                    <v-btn
                        icon
                        medium
                        class="mr-1"
                    >
                        <v-icon
                        medium
                        color="grey darken-3"
                        >
                            arrow_back
                        </v-icon>
                    </v-btn>
                    Log Out
                    </v-card>
                </v-hover>
                </v-row>
            </v-list>
        </v-navigation-drawer>
    </v-content>
</template>

<script>
  import Authorization from '@/components/login/Auth.vue'

  export default {
    data: () => ({
      focusColor: 'grey lighten-2',
      mainColor: 'white',
      nav: [
        {
          icon: 'date_range',
          access: 'user',
          href: 'menu', 
          title: 'Menu'
        },
        {
          icon: 'search',
          access: 'user',
          href: 'recipes',
          title: 'Recipes'
        },
        {
          icon: 'view_list',
          access: 'admin',
          href: 'ingredients',
          title: 'Ingredients'
        },
        {
          icon: 'tune',
          access: 'user',
          href: 'preferences',
          title: 'Preferences'
        },
        {
          icon: 'person',
          access: 'user',
          href: 'account',
          title: 'Account'
        },
      ],
    }),

    components: {
      Authorization
    },

    methods: {
      signOut() {
        this.$store.dispatch('login/signOut');
        this.$router.push('/');
      },

      openAuthDialog() {
        this.$store.dispatch('login/currentAuthView',"SignIn")
        this.$store.dispatch('login/authDialog',true);
      },

      closeAuthDialog() {
        this.$store.dispatch('login/authDialog',false);
        this.$store.dispatch('login/currentAuthView',"SignIn");
        this.$store.dispatch('login/updateUsername',null);
        this.$store.dispatch('login/showConfirmUser',false);
      },

      redirectToMenu() {
        this.$router.push('/menu');
      }

    },

    computed: {
        signedIn() {
            return this.$store.getters['login/signedIn'];
        },

        menu: {
            get() {
                return this.$store.getters['data/navMenu'];
            },
            set(value) {
                this.$store.dispatch('data/updateNavMenu',value);
            }
        },

        adminView: {
            get() {
                return this.$store.getters['data/adminView'];
            },
            set(value) {
                this.$store.dispatch('data/updateAdminView',value);
            }
        },

        account() {
            return this.$store.getters['data/account']
        },
        
        authDialog() {
            return this.$store.getters['login/authDialog'];
        },

        showHeader() {
            if (this.$route.name == 'signup' | this.signedIn == true) {
                return false
            } else {
                return true
            }
        },

    }

  }
</script>